import { Component, Input } from '@angular/core';
import { MarkdownComponent } from "../../../../../shared/components/markdown/markdown.component";
import { AssetVersionPipe } from "../../../../../../app/pipes/asset-version.pipe";
import { NgIf } from "@angular/common";

@Component({
  selector: 'app-copilot-insights-message',
  imports: [
    MarkdownComponent,
    NgIf,
    AssetVersionPipe
  ],
  templateUrl: './copilot-insights-message.component.html',
  styleUrl: './copilot-insights-message.component.scss'
})
export class CopilotInsightsMessageComponent {
  @Input() insights: string | undefined;

}
